import * as React from 'react';
import * as Session from '../../service/Session';
import * as RB from 'react-bootstrap';
import * as TF from '../../service/tradeflow';
import * as DTO from '../../service/DTOs';


type ChatInputProps = {
    //syshdr: DTO.SystemHeader;
    user: Session.UserState,
    xsrfToken?: string,
    personalState?: Session.PersonalState,
    idchat?: number
};

interface ChatInputState {
    //syshdr: DTO.SystemHeader;

    user: Session.UserState;
    currentMessage?: string;
}


export class ChatInput extends React.Component<ChatInputProps, ChatInputState> {
    msgElem: HTMLInputElement | null = null;
    formRef: HTMLFormElement | null = null;

    constructor(props: ChatInputProps) {
        super(props);

        this.state = {
            ...{ user: props.user }
        };

        this.handleMessageChange = this.handleMessageChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }


    handleMessageChange(event: any) {
        this.setState({
            currentMessage: event.target.value
        });
    }

    onSubmit(event: any) {
        event.preventDefault();
        this.postTextMessage(this);
    }

    private postTextMessage(that: ChatInput) {
        let currentMessage = that.state.currentMessage;
        if (!currentMessage || currentMessage.trim().length === 0) {
            return;
        }
        else {
            TF.PostTextMessage(this.state.user.identityState.userName, currentMessage, this.props.idchat);
            this.setState({
                currentMessage: ''
            });
            this.focusField(this);
        }
    }

    private focusField(that: ChatInput) {
        if (that.msgElem)
            that.msgElem.focus();
    }


    onEnterPress = (e: any) => {
        if (e.keyCode == 13 && e.shiftKey == false) {
            e.preventDefault();
            this.postTextMessage(this);
            //if (this.formRef)
            //    this.formRef.submit();

            return false;
        }
    }

    //className = 'panel-footer'
    render() {
        return <div>
            <form ref={el => this.formRef = el} onSubmit={this.onSubmit}>
                <div className="form-group" style={{ marginBottom: '2px' }}>
                    <button className='btn btn-primary'><span className="glyphicon glyphicon-send" />&nbsp;Отправить</button>
                </div>
                <div className="form-group">
                    <label className='sr-only' htmlFor='msg'>Messages</label>

                    <RB.FormControl componentClass="textarea" placeholder='Ваше сообщение'
                        value={this.state.currentMessage ? this.state.currentMessage : ''}
                        name='msg'
                        onChange={this.handleMessageChange}
                        id='msg'
                        inputRef={(input) => { this.msgElem = input }} maxLength={500}
                        onKeyDown={this.onEnterPress}
                    />


                </div>
            </form>
        </div>
    }
}